import React from 'react';
import { motion } from 'framer-motion';

const items = [
  { title: 'Missed-call recovery', desc: "Answers calls your team couldn't reach. Captures who called, why, and what they need." },
  { title: 'After-hours answering', desc: 'Handles calls outside business hours with the same quality as in-hours intake.' },
  { title: 'Overflow answering', desc: 'Catches calls during high-volume periods when your team is occupied.' },
  { title: 'Lead capture and qualification', desc: 'Asks the right questions to qualify the inquiry before routing.' },
  { title: 'Job and appointment intake', desc: 'Collects job details, urgency, location, and scheduling preferences.' },
  { title: 'CRM / SMS / email / Slack handoff', desc: 'Sends structured summaries to wherever your team actually works.' },
];

const WhatItHandles = () => (
  <section className="py-20 border-t" style={{ background: '#0a0a0a', borderColor: '#1a1a1a' }}>
    <div className="max-w-7xl mx-auto px-6 lg:px-8">
      <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="mb-12">
        <p className="text-xs font-bold uppercase tracking-widest mb-4" style={{ color: '#4ade80' }}>Capabilities</p>
        <h2 className="text-3xl md:text-4xl font-bold" style={{ color: '#f1f1f1' }}>What the system actually does.</h2>
      </motion.div>
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
        {items.map((item, i) => (
          <motion.div key={i} initial={{ opacity: 0, y: 16 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
            transition={{ delay: i * 0.07 }}
            className="p-6 rounded-xl border" style={{ background: '#111', borderColor: '#1f1f1f' }}>
            <h3 className="text-sm font-semibold mb-2" style={{ color: '#f1f1f1' }}>{item.title}</h3>
            <p className="text-sm leading-relaxed" style={{ color: '#666' }}>{item.desc}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);

export default WhatItHandles;